import { render, staticRenderFns } from "./ChangeCellphone.vue?vue&type=template&id=24056071&"
import script from "./ChangeCellphone.vue?vue&type=script&lang=js&"
export * from "./ChangeCellphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports